import script from "./EditProductModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProductModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__